import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Cropper from 'react-cropper'
import Widget from '../../../components/widget'
import api from '../../../actions/api'
import { toastError } from '../../../actions/toast'
import { handleError } from '../../../actions/handle-error'
import { update } from '../../../actions/pages/tillage.service'
import { fetchImage, saveImage } from '../../../actions/aws.service'

import InputFile from '../../../components/input-file'

class Index extends Component {

  constructor() {
    super();

    this.submit = this.submit.bind(this)

    this.state = {
      tillage: '',
      loading: true,
      imageUrl: '',
      croppedImage: null,
      cultivationId: ''
    }
  }

  async componentDidMount() {
    const { tillageId, cultivationId } = this.props.match.params
    await this.setState({ cultivationId: cultivationId })

    if (tillageId) this.getTillage(tillageId);
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels: croppedAreaPixels })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  onFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const imageDataUrl = await this.readFile(e.target.files[0])
      this.setState({
        imageUrl: imageDataUrl,
        crop: { x: 0, y: 0 },
        zoom: 1,
      })
    }
  }

  readFile(file) {
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.addEventListener('load', () => resolve(reader.result), false)
      reader.readAsDataURL(file)
    })
  }

  submit(e) {
    e.preventDefault()

    if (typeof this.cropper.getCroppedCanvas() === 'undefined') return;

    const data = this.cropper.getCroppedCanvas().toDataURL();

    this.setState({ croppedImage: data });

    if (data) this.save(data);

    return false
  }

  getTillage = async id => {
    await api.get(`tillages/${id}`)
      .then(result => {
        const tillage = result.data;

        const imageUrl = fetchImage(tillage.thumbnail, 'tillages') || '../../../../assets/images/crop.png';

        this.setState({
          tillage: tillage,
          imageUrl: imageUrl

        });

        this.props.dispatch({
          type: 'SET_BREADCRUMB',
          items: [
            { page: 'Home', url: '/' },
            { page: 'Safras', url: '/crops' },
            { page: `${tillage.crop.name}`, url: `/crops/${tillage.crop.id}` },
            { page: `${tillage.name}`, url: `tillages/${tillage.id}` },
            { page: 'Alterar Imagem', url: '#' },
          ]
        })
      }).catch(error => {
        if (error.response.status === 500) this.props.history.push('/tillages')
        toastError(handleError(error))
      });
  }

  save = async (croppedImage) => {
    const { tillage } = this.state

    tillage.thumbnail = await saveImage(tillage.name, tillage.id, croppedImage, 'tillages');

    const resolve = await update(tillage);
    if (resolve) {
      setTimeout(() => {
        this.props.history.push(`/cultivations/${tillage.cultivationId}/tillages/${tillage.id}`);
      }, 500);
    }
  }

  render() {
    const photo = this.state;

    return (
      <Widget
        title="Alterar Imagem">
        <div className="row">
          <div className="col">
            <div className="col">
              <Cropper
                style={{ height: 350, width: '100%' }}
                aspectRatio={2 / 2}
                guides={false}
                src={photo.imageUrl}
                ref={cropper => { this.cropper = cropper; }}
              />
            </div>

            <div className="row col justify-content-center mt-4 p-0">
              <div className="mr-2">
                <InputFile
                  label="Escolher Imagem"
                  icon={true}
                  onChange={this.onFileChange}
                />
              </div>

              {/* <Link to="#" className="mr-2">
                  <button className="btn btn-success btn-icon text-white">
                    <i className="material-icons">add_a_photo</i>
                    <span>Capturar Imagem</span>
                  </button>
                </Link> */}

              <Link to="#" className="mr-2">
                <button
                  className="btn btn-success text-white"
                  onClick={this.submit}>
                  {photo.tillage.thumbnail ? 'Atualizar' : 'Salvar'}
                </button>
              </Link>

              <Link to={`/cultivations/${photo.cultivationId}/tillages/${photo.tillage.id}`}>
                <button
                  className="btn btn-success btn-outline">
                  Voltar
                    </button>
              </Link>
            </div>

          </div>
        </div>
      </Widget >
    )
  }
}

export default Index;